import React, { useEffect } from 'react'
import {
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  MenuDivider,
  Box,
  Text
} from '@chakra-ui/react'
import { graySoft, violet } from '@qirapagos/lib/theme/colors'
import { useTable } from 'hooks/useTable'
import CustomFilter from './CustomFilter'

interface Props {
  filterOptions?: string[]
  onFilter?: any
  shouldOpenDrawer?: boolean
}

// TODO: refactor CustomText to a web version

const FilterTable: React.FC<Props> = ({
  filterOptions,
  onFilter,
  shouldOpenDrawer
}) => {
  const { handleDrawer, selectedDateFilter, selectedFilter } = useTable()

  useEffect(() => {
    if (!shouldOpenDrawer) return

    if (!selectedDateFilter) {
      onFilter?.(null)
      return
    }

    const [fromStr, toStr] = selectedDateFilter.split(' - ')

    const range = {
      from: fromStr ? new Date(fromStr) : undefined,
      to: toStr ? new Date(toStr) : undefined
    }

    if (range.to) {
      range.to.setHours(23, 59, 59, 999)
    }

    onFilter?.(range)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedDateFilter, shouldOpenDrawer])

  return (
    <Box>
      {shouldOpenDrawer
        ? (
          <button type="button" onClick={() => handleDrawer()}>
            <CustomFilter title={selectedDateFilter} />
          </button>
          )
        : (
          <Menu id="testId">
            <MenuButton>
              <CustomFilter title={selectedFilter} />
            </MenuButton>
            <MenuList textAlign="end" p={0}>
              {filterOptions?.map(option => (
                <>
                  <MenuItem
                    key={option}
                    onClick={() => onFilter(option)}
                    h="40px"
                    alignSelf="end"
                    justifySelf="end"
                    _focus={{ color: violet, bg: graySoft }}
                    id={`id-${option}`}
                  >
                    <Box w="100%" textAlign="end">
                      <Text
                        w="100%"
                        fontFamily="Poppins"
                        fontSize="15px"
                        fontWeight={500}
                      >
                        {option}
                      </Text>
                    </Box>
                  </MenuItem>
                  {option !== filterOptions[filterOptions.length - 1] && (
                  <MenuDivider m={0} />
                  )}
                </>
              ))}
            </MenuList>
          </Menu>
          )}
    </Box>
  )
}

export default FilterTable

FilterTable.defaultProps = {
  filterOptions: [],
  onFilter: () => null,
  shouldOpenDrawer: false
}
